import { render } from "./Countup.vue?vue&type=template&id=2a0e9504"
import script from "./Countup.vue?vue&type=script&lang=js"
export * from "./Countup.vue?vue&type=script&lang=js"

import "./Countup.vue?vue&type=style&index=0&id=2a0e9504&lang=scss"

import exportComponent from "/Users/david.haas/Documents/Projects/VSC/ommax-employer-branding-lp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__